module.exports = __webpack_public_path__ + "img/avatar_teacher2.3e48162f.png";